import {REPORT_CONFIGURATION_NAME} from 'components/report-configuration/report-configuration.constants';
import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

export const useEnableDynamicSql = (): boolean => {
    const {hasUserRoleFunction} = useUserRoleFunctions({
        sections: [REPORT_CONFIGURATION_NAME],
    });

    return hasUserRoleFunction(EUserRoleFunction.ENABLE_DYNAMIC_SQL);
};
